import { WeekDaysEnum } from '../SubscriptionPageInfo'

export const formatWeekDays = (days: WeekDaysEnum[]): string | null => {
  if (days.length === 0) return null
  const week = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
  const indices = days.map(day => week.indexOf(day)).filter(i => i !== -1)

  // Проверка, идут ли дни по порядку
  const isSorted = indices.every((val, i, arr) => i === 0 || val >= arr[i - 1])

  if (!isSorted) {
    return days.join(', ')
  }

  // Удаление дубликатов и сортировка
  const uniqueSorted = [...new Set(indices)].sort((a, b) => a - b)
  const result = []

  let i = 0
  while (i < uniqueSorted.length) {
    let start = i
    while (i + 1 < uniqueSorted.length && uniqueSorted[i + 1] === uniqueSorted[i] + 1) {
      i++
    }

    if (i > start) {
      if (i - start > 2) {
        result.push(`${week[uniqueSorted[start]]}-${week[uniqueSorted[i]]}`)
      } else {
        let count = start
        while (count <= i) {
          result.push(week[uniqueSorted[count]])
          count++
        }
      }
    } else {
      result.push(week[uniqueSorted[i]])
    }
    i++
  }

  return result.join(', ')
}
